'use client';

import { useEffect, useState } from 'react';
import { Heading } from '../../../components/Heading/Heading';
import { useClientHasRendered } from '../../../helpers/hooks';
import { useCoupon } from '../../../helpers/hooks/useCoupon';
import { useUserInfo } from '../../../helpers/hooks/useUserInfo';
import { FREE_TRIAL_DAYS } from '../../../constants/premium';

export const ProHeadlineSection = ({ couponCode }: { couponCode?: string }) => {
  const { premiumEndDate, isLoadingUser } = useUserInfo();
  const { coupon, isLoading: couponIsLoading } = useCoupon(couponCode);
  const clientHasRendered = useClientHasRendered();
  const [userHasBeenPro, setUserHasBeenPro] = useState(false);

  useEffect(() => {
    if (premiumEndDate && clientHasRendered) {
      const currentDate = new Date();
      const result = premiumEndDate.localeCompare(currentDate.toString());
      setUserHasBeenPro(result <= 0);
    }
  }, [clientHasRendered, premiumEndDate]);

  if (couponIsLoading || isLoadingUser) {
    return <></>;
  }

  if (userHasBeenPro || coupon) {
    return (
      <Heading as="h1" className="mt-0 mb-3 text-center whitespace-pre-line md:text-left">
        {`Fishbrain Pro
        A smarter way to fish`}
      </Heading>
    );
  }

  return (
    <Heading as="h1" className="mt-0 mb-3 text-center whitespace-pre-line md:text-left">
      {' '}
      {`Try Fishbrain Pro 
                            ${FREE_TRIAL_DAYS} days for free`}{' '}
    </Heading>
  );
};
